export default "__VITE_ASSET__DRujNXlI__"